import React from 'react';
import { Row, Col, Descriptions } from 'antd';
import { FormattedMessage } from 'react-intl';
import ImportButton from './ImportButtonApplications';

const SummaryApplications: React.FC<any> = (props: any) => {
  const { summary = undefined, applications } = props;

  if (applications === undefined) window.location.href = '#/import/applications';

  return (
    <div>
      <div
        style={{
          backgroundColor: '#ffffff',
          marginBottom: '20px',
        }}
      >
        <Descriptions
          title="applications"
          column={{ lg: 4, md: 3, sm: 2, xs: 1 }}
          size="small"
          bordered
        >
          <Descriptions.Item label={<FormattedMessage id="import.applications.summary.all" />}>
            {summary && summary.all ? summary.all : 0}
            {'  '}
            <FormattedMessage id="import.applications.summary.applications" />
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage id="import.applications.summary.normal" />}>
            {summary && summary.normal ? summary.normal : 0}
            {'  '}
            <FormattedMessage id="import.applications.summary.applications" />
          </Descriptions.Item>
          <Descriptions.Item
            label={<FormattedMessage id="import.applications.summary.duplicate" />}
          >
            {summary && summary.duplicate ? summary.duplicate : 0}
            {'  '}
            <FormattedMessage id="import.applications.summary.applications" />
          </Descriptions.Item>
        </Descriptions>
        <br />
        <Row gutter={24}>
          <Col span={24}>
            <ImportButton applications={applications} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SummaryApplications;
